import React from 'react'
import { useTranslation } from 'react-i18next'

export const Footer: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="flex">
      <div className="hidden sm:block mr-5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100"
          height="100"
          viewBox="0 0 866 866"
        >
          <g fill="none" stroke="#797775" strokeWidth="8" strokeMiterlimit="10">
            <path d="M1 865h289"></path>
            <path d="M577 865.68h289"></path>
            <path d="M1.25 866V289.25c3.7-76.86 20.83-160.01 74.58-215.13C129.68 18.88 211.21-2.71 288.2 1.51c70.87 3.89 132.51 37.63 179.9 97.65 43.92 55.63 75 114.36 109.65 188.45C704.78 541.7 770.2 674.04 866 865.75"></path>
            <path d="M289.48 865.75V287.61c.19.37 95.94 193 287.52 578.39"></path>
          </g>
          <g className="lines" fill="none" stroke="#797775" strokeWidth="6">
            <g strokeMiterlimit="10">
              <path d="M1.25 865.75V289.44"></path>
              <path d="M289.5 865.75V1"></path>
              <path d="M577.97 866V0"></path>
              <path d="M865 867V1"></path>
            </g>
            <g>
              <path strokeMiterlimit="10" d="M1 577.5h865"></path>
              <path d="M1.25 289.25H866"></path>
              <path d="M289.5 1h603.25"></path>
            </g>
          </g>
        </svg>
      </div>
      <div className="flex flex-column justify-content-between">
        <span className="text-400 text-sm md:text-base mb-2">
          {t('maintenance.footer.productBy')}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="172"
          height="35"
          viewBox="0 0 172 35"
          aria-label="NTT DATA Logo"
        >
          <path
            fill="#797775"
            fill-rule="evenodd"
            d="M18.5 30.4c-7.6 0-14-6.1-14-14 0-7.2 5.2-12.1 9.3-11.9-1.9 1.9-3.1 4.7-3.1 7.4 0 4.7 3.7 7.9 7.8 7.9s7.8-3.3 7.8-7.9c0-2.7-1.2-5.5-3.1-7.4 4.1-.2 9.3 4.7 9.3 11.9 0 7.9-6.4 14-14 14m0-24.7c1.4.8 3.3 3.3 3.3 6.1 0 2-1.3 3.6-3.3 3.6-2 0-3.3-1.6-3.3-3.6 0-2.8 1.9-5.3 3.3-6.1M23 0c-1.7 0-3.3.4-4.5.8C17.3.4 15.7 0 14 0 6.7 0 0 7 0 16.5 0 26.9 8.5 35 18.5 35S37 26.9 37 16.5C37 7 30.3 0 23 0"
            clip-rule="evenodd"
          ></path>
          <path
            fill="#797775"
            d="M64 8v3.8h5.5V26h4V11.8H79V8zM125.3 22.2c-.6 0-1.3-.3-1.3-1.9 0-1.5.7-1.8 1.3-1.8h7.7v3.7h-7.7zM131.2 8H121v3.8h10c1.5 0 2 .7 2 2.4v.6h-8.3c-3.1 0-4.7 1.6-4.7 5.2v.9c0 3.7 1.6 5.1 4.9 5.1H137V14.2c0-4.6-1.5-6.2-5.8-6.2M160.3 22.2c-.6 0-1.3-.3-1.3-1.9 0-1.5.7-1.8 1.3-1.8h7.7v3.7h-7.7zM166.2 8H156v3.8h10c1.5 0 2 .7 2 2.4v.6h-8.3c-3.1 0-4.7 1.6-4.7 5.2v.9c0 3.7 1.6 5.1 4.9 5.1H172V14.2c0-4.6-1.5-6.2-5.8-6.2M81 8v3.8h5.5V26h4V11.8H96V8zM114.8 19.8c0 1.7-.6 2.4-2.1 2.4h-6.6V11.8h6.6c1.5 0 2.1.7 2.1 2.4v5.6zm4.2-.1v-5.4c0-4.7-1.8-6.3-6-6.3h-11v18h11.2c4.4 0 5.8-2.2 5.8-6.3M138 8v3.8h5.5V26h4V11.8h5.5V8zM57.6 22.4c-.1-.2-5.6-11.2-6.3-12.2-.8-1.3-1.8-2.2-3.6-2.2-1.7 0-3.7.8-3.7 4.9v13.9h4.1V15.2c0-.8-.1-2.1-.1-2.3 0-.2 0-.4.1-.5.1-.1.2 0 .3.2.1.2 5.2 10.5 6.3 12.2.8 1.3 1.7 2.1 3.6 2.1 1.7 0 3.7-.8 3.7-4.9V8.2h-4.1v11.6c0 .8 0 2.1.1 2.3 0 .2 0 .4-.1.5-.1 0-.3-.1-.3-.2"
          ></path>
        </svg>
        <a
          href="https://nttdata-solutions.com/?__hstc=216541449.1531cf01969ed3acaeda64fcf1ddb653.1749122993893.1749122993893.1749562055746.2&amp;__hssc=216541449.2.1749562055746&amp;__hsfp=2955168314"
          className="text-400 text-sm md:text-base hover:no-underline mt-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('maintenance.footer.nttDataLinkText')}
        </a>
      </div>
    </div>
  )
}
